import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { EmploymentJourney } from "@/features/individuals/components/employment-journey"
import { describing } from "@/lib/subject"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/"
)({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      individualQueries.detail(params.individualId)
    )
    await context.queryClient.ensureQueryData(
      individualQueries.employments(params.individualId)
    )
  },
  component: AddEmploymentPage,
})

function AddEmploymentPage() {
  const { individualId } = Route.useParams()
  const navigate = useNavigate()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <EmploymentJourney
      individualId={individualId}
      subject={describing(individual.firstName)}
      onFinished={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/individuals/$individualId/employment",
          params: { individualId },
        })
      }
    />
  )
}
